module.exports = __webpack_public_path__ + "img/news33-0.9a38b885.png";